function Support() {
  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <h1 style={styles.title}>Support</h1>
        <p style={styles.description}>
          Have feedback, questions, or bug reports?
          <br />
          Contact us directly at:
        </p>
        <p style={styles.email}>
          <a href="mailto:info@cheerclip.com" style={styles.link}>
            info@cheerclip.com
          </a>
        </p>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #e6fffa, #ffffff)',
  },
  card: {
    background: 'white',
    padding: '3rem',
    borderRadius: '16px',
    boxShadow: '0 12px 28px rgba(0,0,0,0.1)',
    textAlign: 'center',
    maxWidth: '500px',
    width: '100%',
  },
  title: {
    fontSize: '2.5rem',
    color: '#234e52',
    marginBottom: '1rem',
  },
  description: {
    fontSize: '1rem',
    color: '#4a5568',
    marginBottom: '1rem',
  },
  email: {
    fontSize: '1.1rem',
    fontWeight: 'bold',
  },
  link: {
    color: '#2c7a7b',
    textDecoration: 'underline',
  },
};

export default Support;
